// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"fb6ebaae","239":"70ed15e3","453":"be795ba1"}[chunkId] + ".chunk.js";
};